import React, { useCallback } from 'react';

import {
  IconButton,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  EditIcon,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { DateRangeFormatter, NumberValueFormatter } from '@gogame/intl-ts';

import {
  ACTIVITY_TYPE_RE,
  ACTIVITY_TYPE_TOTAL,
  ACTIVITY_TYPE_UA,
} from 'scenes/Campaigns/components/CostModel';

import { CostModelFormEditExisting } from 'scenes/Campaigns/GGCampaigns/components/CostModelForm';

export const CostModels = ({ models, campaignId, editable }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleEditCostModel = useCallback(
    (index) => {
      openChildComponent(CostModelFormEditExisting, {
        id: models[index]?.subType?.id || models[index]?.type?.id,
        campaignId,
        initialValues: models[index],
      });
    },
    [models, campaignId]
  );

  return (
    <React.Fragment>
      {childComponent}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Event</TableCell>
              <TableCell>Period</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell width={'73px'}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {models.map((data, index) => {
              const activityType = data?.periods?.[0]?.activityType;
              let name = data.type.name;
              switch (activityType) {
                case ACTIVITY_TYPE_UA:
                  name += ` (UA)`;
                  break;
                case ACTIVITY_TYPE_RE:
                  name += ` (RE)`;
                  break;
                case ACTIVITY_TYPE_TOTAL:
                  name += ` (Total)`;
                  break;
              }
              return (
                <TableRow key={index}>
                  <TableCell>{name}</TableCell>
                  <TableCell>{data?.subType?.name || '-'}</TableCell>
                  <TableCell>
                    {data.periods[0].period && (
                      <DateRangeFormatter
                        value={Object.values(data.periods[0].period)}
                        template={'dd MMM, yyyy'}
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    <NumberValueFormatter.Currency
                      value={data?.periods?.[0].rate?.value}
                      currency={data?.periods?.[0].rate?.currency}
                      precision={2}
                    />
                  </TableCell>
                  <TableCell width={'73px'} padding={'none'}>
                    <IconButton
                      padding={'0px 0px'}
                      icon={<EditIcon />}
                      tooltip={'Edit'}
                      onClick={() => handleEditCostModel(index)}
                      disabled={!editable}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};
